import styled from "styled-components";

interface InfoContainerProps {
  color?: string;
}

interface IconContainerProps {
  color: string;
}

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const WindowContainer = styled.div`
  height: fit-content;
  
  .communication {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #666666;

    svg {
      height: 20px;
      fill: #64dd17;
      margin-right: 4px;
    }
  }
`;

const InfoContainer = styled.div<InfoContainerProps>`
  display: flex;
  align-items: center;

  font-size: 13px;
  font-weight: 400;
  color: #666666;
  
  margin-bottom: 24px;

  .inlineContent {
    display: inline-flex;
    > div {
      margin-right: 5px;
    }
  }

  .titleContent {
    font-weight: 700;
    color: #000;
  }

  .contentColor {
    color: ${({ color }) => color};
    font-weight: 600;
  }
`;

const IconContainer = styled.div<IconContainerProps>`
  margin-right: 15px;

  svg {
    fill: ${({ color }) => color};
  }
`;

export { Container, InfoContainer, WindowContainer, IconContainer };
